import React from 'react';
import '../HomePage.css';
import { useAuth } from '../AuthContext';

const MentorSuggestion = () => {
    const { userData } = useAuth();

    return (
        <div className="mentor-suggestion-container">
            <h2 className="mentor-suggestion-heading">Welcome, {userData.name}!</h2>
            <p className="mentor-intro">
                As a mentor, your role is crucial in guiding aspiring individuals towards success. Here are some suggestions on how you can refine your mentoring strategies to make a lasting impact.
            </p>

            <section className="mentor-suggestion-section">
                <h3 className="mentor-suggestion-subheading">1. Tailor Your Approach</h3>
                <p className="mentor-suggestion-text">
                    Each mentee comes with their unique challenges and goals. One of the best ways to provide value is by understanding their individual needs. Adjust your mentoring approach accordingly:
                </p>
                <ul className="mentor-suggestion-list">
                    <li>Ask open-ended questions to better understand their motivations and aspirations.</li>
                    <li>Identify their strengths and areas for improvement, and help them leverage those strengths.</li>
                    <li>Offer constructive feedback, focusing on growth rather than criticism.</li>
                </ul>
            </section>

            <section className="mentor-suggestion-section">
                <h3 className="mentor-suggestion-subheading">2. Case Study: Overcoming Challenges</h3>
                <p className="mentor-suggestion-text">
                    In one of our recent case studies, a mentee struggled with time management and balancing personal commitments with their professional goals. Here's how you can help in similar situations:
                </p>
                <ul className="mentor-suggestion-list">
                    <li>Share strategies such as the Pomodoro technique to enhance productivity.</li>
                    <li>Help them create a clear schedule that balances their priorities.</li>
                    <li>Provide motivational stories or examples of others who overcame similar obstacles.</li>
                </ul>
            </section>

            <section className="mentor-suggestion-section">
                <h3 className="mentor-suggestion-subheading">3. Giving Constructive Feedback</h3>
                <p className="mentor-suggestion-text">
                    Providing feedback is one of the most valuable aspects of mentoring. However, it's important to strike the right balance. Here’s how you can improve your feedback delivery:
                </p>
                <ul className="mentor-suggestion-list">
                    <li>Use the "SBI" method: Situation-Behavior-Impact. Discuss the situation, describe the behavior, and explain the impact of their actions.</li>
                    <li>Be specific in your feedback rather than vague generalizations.</li>
                    <li>Ensure that feedback is actionable, offering advice on how the mentee can improve.</li>
                </ul>
            </section>

            <section className="mentor-suggestion-section">
                <h3 className="mentor-suggestion-subheading">4. Personal Development Tips</h3>
                <p className="mentor-suggestion-text">
                    To be an effective mentor, you must also invest in your personal growth. Here are some tips to help you excel in your mentorship role:
                </p>
                <ul className="mentor-suggestion-list">
                    <li>Continue learning about new trends in your field to stay relevant and provide valuable insights.</li>
                    <li>Attend mentorship training sessions to improve your communication and coaching skills.</li>
                    <li>Join mentor communities to exchange experiences and best practices with others.</li>
                </ul>
            </section>

            <section className="mentor-suggestion-section">
                <h3 className="mentor-suggestion-subheading">5. Building Long-Term Relationships</h3>
                <p className="mentor-suggestion-text">
                    Successful mentoring relationships go beyond just providing guidance. It's essential to build trust and a meaningful connection with your mentees:
                </p>
                <ul className="mentor-suggestion-list">
                    <li>Be approachable and available, ensuring your mentees feel supported.</li>
                    <li>Encourage an open line of communication, allowing your mentees to reach out when needed.</li>
                    <li>Celebrate their successes, no matter how small, to keep them motivated.</li>
                </ul>
            </section>
        </div>
    );
};

export default MentorSuggestion;
